import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Box, IconButton, ImageList, ImageListItem } from "@mui/material";
import { FormEvent, useEffect, useState } from "react";
import { createApi } from "unsplash-js";

import useMediaQuery from "../../customHooks/useMediaQuery";
import Image from "../Image";
import Loader from "../Loader";
import PhotoDetailsModal from "../profile/PhotoDetailsModal";
import TextField from "../TextField";
import Typography from "../Typography";

interface ImageSuggestionProps {
  handleChoose: (url: string) => void;
  defaultSearchQuery?: string;
}

const ImageSuggestion = ({
  handleChoose,
  defaultSearchQuery = "Food catering",
}: ImageSuggestionProps) => {
  const [suggestedImages, setSuggestedImages] = useState<string[]>();
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>();
  const [searchQuery, setSearchQuery] = useState(defaultSearchQuery);
  const isMdSize = useMediaQuery("(min-width:900px)");
  const unsplash = createApi({
    accessKey: process.env.NEXT_PUBLIC_UNSPLASH_API_KEY!,
  });
  useEffect(() => {
    setSuggestedImages(undefined);
    unsplash.search
      .getPhotos({ query: searchQuery })
      .then((result) => {
        setSuggestedImages(
          result.response?.results.map((each) => each.urls.regular)
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }, [searchQuery]);

  const handleSearch = (event: FormEvent<HTMLFormElement> | undefined) => {
    event?.preventDefault();
    setSearchQuery((event?.target as any).searchQuery.value);
  };

  return (
    <Box>
      <Box
        component="form"
        onSubmit={handleSearch}
        sx={{
          display: "flex",
          alignItems: "flex-end",
          gap: 2,
        }}
      >
        <TextField
          name="searchQuery"
          containerSx={{ maxWidth: "300px" }}
          initialValue={searchQuery}
          label={"Custom search"}
        />
        <IconButton type="submit" sx={{ height: "60px", width: "60px" }}>
          <SearchRoundedIcon sx={{ fontSize: "27px" }} />
        </IconButton>
      </Box>
      <Typography
        variant="body2"
        sx={{
          marginTop: 1,
        }}
      >
        Choose image
      </Typography>
      <Box sx={{ maxWidth: { md: "700px", xs: "100%" } }}>
        {suggestedImages ? (
          <ImageList
            sx={{
              "& li": {
                borderRadius: "6px",
                overflow: "hidden",
              },
            }}
            gap={isMdSize ? 16 : 8}
            cols={isMdSize ? 5 : 3}
          >
            {suggestedImages.map((image, index) => (
              <ImageListItem
                sx={{
                  aspectRatio: "1/1",
                  cursor: "pointer",
                  "& img": {
                    height: "100% !important",
                  },
                }}
                key={index}
                onClick={() => {
                  setSelectedImageIndex(index);
                }}
              >
                <Image
                  src={image}
                  style={{ flexGrow: 1, objectFit: "cover" }}
                />
              </ImageListItem>
            ))}
          </ImageList>
        ) : (
          <Box sx={{ width: "700px", height: "300px" }}>
            <Loader />
          </Box>
        )}
      </Box>
      {typeof selectedImageIndex === "number" && suggestedImages && (
        <PhotoDetailsModal
          readOnly={true}
          handleImageChoose={(url) => {
            setSelectedImageIndex(undefined);
            handleChoose(url);
          }}
          handleClose={() => {
            setSelectedImageIndex(undefined);
          }}
          imgUrl={suggestedImages[selectedImageIndex]}
          open={typeof selectedImageIndex === "number"}
        />
      )}
    </Box>
  );
};

export default ImageSuggestion;
